import React from "react";

import { useTranslation } from "react-i18next";

import { isCapacitorPlatform } from "@utils/specific/capacitor";

export default function CapacitorAppDisabledPopup() {
	const { t } = useTranslation();

	if (
		!WEBPACK_CAPACITOR_ENABLED ||
		!isCapacitorPlatform() ||
		!WEBPACK_CAPACITOR_BLOCK_UPDATE_ENABLED
	) {
		return null;
	}

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__body u-padd--top--big u-padd--bottom--xsml u-type--center">
					<i className="u-icon u-icon--huge u-icon--empty u-icon--empty--app" />
					<div className="u-mar--bottom--xtny u-type--med">
						{t("CAPACITOR_UPDATE.APP_UPDATE_TITLE")}
					</div>
					<div className="u-type--base">
						<div>{t("CAPACITOR_UPDATE.UNSUPORRTED_VERSION")}</div>

						<div>
							{t(
								"CAPACITOR_UPDATE.UNSUPPORTED_VERSION_UPDATE_INFO"
							)}
						</div>
					</div>
				</div>
				<div className="popup__footer" />
			</div>
		</div>
	);
}
